(function() {
  if (window.__HC_CUSTOM_THEME__) return;
  window.__HC_CUSTOM_THEME__ = true;

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2
    }).format(amount);
  }

  function getSampleConfig() {
    const script = document.getElementById('hc-sample-limits');

    if (!script) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (_error) {
      return null;
    }
  }

  function getModalRoot() {
    return document.querySelector('.hc-modal-root');
  }

  function showSampleLimitModal(message) {
    const root = getModalRoot();
    const overlay = root?.querySelector('[data-hc-modal-overlay]');
    const messageElement = root?.querySelector('.hc-error-message');
    const fallbackMessage = messageElement?.dataset?.defaultMessage || messageElement?.textContent || 'Sample limit reached';
    const nextMessage = String(message || fallbackMessage || '').trim();

    if (messageElement) {
      if (!messageElement.dataset.defaultMessage) {
        messageElement.dataset.defaultMessage = messageElement.textContent || '';
      }

      messageElement.textContent = nextMessage;
    }

    if (root) {
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      root.classList.add('hc-open');
    }

    overlay?.classList.add('hc-open');
  }

  function closeSampleLimitModal() {
    const root = getModalRoot();
    const overlay = root?.querySelector('[data-hc-modal-overlay]');

    if (root) {
      root.classList.remove('hc-open');
      root.setAttribute('aria-hidden', 'true');
      root.hidden = true;
    }

    overlay?.classList.remove('hc-open');
  }

  function isBreezeTags(tags) {
    return tags.includes('breeze block') || tags.includes('breeze') || tags.includes('breeze_block');
  }

  function normalizeSampleBaseHandle(handle) {
    const rawHandle = String(handle || '');

    if (rawHandle.endsWith('-extra-sample')) {
      return rawHandle.slice(0, -13);
    }

    if (rawHandle.endsWith('-sample')) {
      return rawHandle.slice(0, -7);
    }

    return rawHandle;
  }

  function getScarpaCartRuleConfig() {
    const regularLimitEl = document.querySelector('.hc-regular-items');
    const scarpaLimitEl = document.querySelector('.hc-carpa-items');
    const scarpaPerProductLimitEl = document.querySelector('.hc-carpa-per-product-items');
    const bothErrorEl = document.querySelector('.hc_both_error');

    return {
      regularLimit: parseInt(regularLimitEl?.dataset.limit || '0', 10) || 0,
      scarpaLimit: parseInt(scarpaLimitEl?.dataset.limit || '0', 10) || 0,
      scarpaPerProductLimit: parseInt(scarpaPerProductLimitEl?.dataset.limit || '0', 10) || 0,
      regularError: regularLimitEl?.dataset.error || '',
      scarpaError: scarpaLimitEl?.dataset.error || '',
      scarpaPerProductError: scarpaPerProductLimitEl?.dataset.error || '',
      bothError: bothErrorEl?.dataset.error || ''
    };
  }

  function getCheckoutTargets() {
    return Array.from(document.querySelectorAll('button[name="checkout"], .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart'));
  }

  function setCheckoutDisabledState(disabled) {
    getCheckoutTargets().forEach((element) => {
      element.classList.toggle('hc-checkout-inactive', disabled);
    });
  }

  let scarpaGuardEvalVersion = 0;
  let scarpaGuardEvalTimer = null;
  const scarpaTagCache = {};

  function applyScarpaGuardState(nextState, evalVersion) {
    if (evalVersion < scarpaGuardEvalVersion) {
      return window.__hcScarpaGuardState || { blocked: false, message: '' };
    }

    window.__hcScarpaGuardState = nextState;
    setCheckoutDisabledState(!!nextState.blocked);
    return nextState;
  }

  function scheduleScarpaGuardEvaluation(cartData, delayMs, pessimistic) {
    if (scarpaGuardEvalTimer) {
      clearTimeout(scarpaGuardEvalTimer);
    }

    if (pessimistic) {
      setCheckoutDisabledState(true);
    }

    const wait = typeof delayMs === 'number' ? delayMs : 100;
    scarpaGuardEvalTimer = window.setTimeout(() => {
      scarpaGuardEvalTimer = null;
      evaluateScarpaCheckoutGuard(cartData);
    }, wait);
  }

  async function evaluateScarpaCheckoutGuard(cartData) {
    const evalVersion = ++scarpaGuardEvalVersion;
    const config = getScarpaCartRuleConfig();

    if (!config.regularLimit && !config.scarpaLimit && !config.scarpaPerProductLimit && !config.bothError) {
      return applyScarpaGuardState({ blocked: false, message: '' }, evalVersion);
    }

    try {
      const cart = cartData || await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' })).json();
      const items = Array.isArray(cart?.items) ? cart.items : [];
      const handles = [...new Set(items.map((item) => String(item.handle || '')).filter(Boolean))];
      const tagsByHandle = {};

      await Promise.all(handles.map(async (handle) => {
        if (scarpaTagCache[handle]) {
          tagsByHandle[handle] = scarpaTagCache[handle];
          return;
        }

        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { cache: 'no-store' });

          if (!response.ok) return;

          const product = await response.json();
          const tags = Array.isArray(product.tags) ? product.tags.join(',') : String(product.tags || '');
          scarpaTagCache[handle] = tags.toLowerCase();
          tagsByHandle[handle] = scarpaTagCache[handle];
        } catch (_error) {
        }
      }));

      let scarpaQty = 0;
      let regularQty = 0;
      let anySample = false;
      let scarpaPerProductFail = false;

      items.forEach((item) => {
        const title = String(item.title || item.product_title || '').toLowerCase();
        const handle = String(item.handle || '');

        if (handle.endsWith('-sample') || title.includes('sample')) {
          anySample = true;
          return;
        }

        const qty = parseInt(item.quantity || 0, 10);

        if (!qty || qty <= 0) return;

        const tags = tagsByHandle[handle] || '';
        const isScarpa = tags.includes('carlo_scarpa') || tags.includes('carlo-scarpa');

        if (isScarpa) {
          scarpaQty += qty;
          if (config.scarpaPerProductLimit > 0 && qty < config.scarpaPerProductLimit) {
            scarpaPerProductFail = true;
          }
        } else {
          regularQty += qty;
        }
      });

      const onlySamples = anySample && scarpaQty === 0 && regularQty === 0;

      if (onlySamples) {
        return applyScarpaGuardState({ blocked: false, message: '' }, evalVersion);
      }

      const hasScarpa = scarpaQty > 0;
      const hasRegular = regularQty > 0;
      const hasMixed = hasScarpa && hasRegular;
      const carloFail = hasScarpa && config.scarpaLimit > 0 && scarpaQty < config.scarpaLimit;
      const regularFail = hasRegular && config.regularLimit > 0 && regularQty < config.regularLimit;
      const blocked = hasMixed || scarpaPerProductFail || carloFail || regularFail;

      let message = '';

      if (scarpaPerProductFail && config.scarpaPerProductError) {
        message = config.scarpaPerProductError;
      } else if (hasMixed) {
        message = config.bothError || [config.scarpaError, config.regularError].filter(Boolean).join(' ');
      } else if (carloFail) {
        message = config.scarpaError;
      } else if (regularFail) {
        message = config.regularError;
      }

      return applyScarpaGuardState({ blocked, message }, evalVersion);
    } catch (_error) {
      return applyScarpaGuardState({ blocked: false, message: '' }, evalVersion);
    }
  }

  async function canAddSample(sampleType, baseHandle) {
    const config = getSampleConfig();

    if (!config) return true;

    const matrix = config.isTrade ? config.tradeCustomer : config.regularCustomer;

    if (!matrix) return true;

    try {
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });

      if (!cartResponse.ok) return true;

      const cart = await cartResponse.json();
      const sampleItems = (cart.items || []).filter((item) => {
        const handle = String(item.handle || '');
        const title = String(item.title || item.product_title || '').toLowerCase();

        return handle.endsWith('-sample') || title.includes('sample');
      }).map((item) => {
        return { item, baseHandle: normalizeSampleBaseHandle(item.handle) };
      });

      const handles = [...new Set(sampleItems.map((entry) => entry.baseHandle).concat(baseHandle ? [baseHandle] : []).filter(Boolean))];
      const tagsByHandle = {};

      await Promise.all(handles.map(async (handle) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { cache: 'no-store' });

          if (!response.ok) return;

          const product = await response.json();
          const tags = Array.isArray(product.tags) ? product.tags.join(',') : String(product.tags || '');
          tagsByHandle[handle] = tags.toLowerCase();
        } catch (_error) {
        }
      }));

      let regularCount = 0;
      let scarpaCount = 0;
      let breezeCount = 0;

      sampleItems.forEach(({ item, baseHandle: handle }) => {
        const qty = parseInt(item.quantity || 0, 10);
        const tags = tagsByHandle[handle] || '';
        const isScarpa = tags.includes('carlo_scarpa') || tags.includes('carlo-scarpa');
        const isBreeze = isBreezeTags(tags);

        if (isScarpa) {
          scarpaCount += qty;
        } else {
          regularCount += qty;
        }

        if (isBreeze) {
          breezeCount += qty;
        }
      });

      const baseTags = tagsByHandle[baseHandle] || '';
      const isScarpaBase = baseTags.includes('carlo_scarpa') || baseTags.includes('carlo-scarpa');
      const isBreezeBase = isBreezeTags(baseTags);

      if (sampleType === 'scarpa' || isScarpaBase) {
        scarpaCount += 1;
      } else {
        regularCount += 1;
      }

      if (sampleType === 'breeze' || isBreezeBase) {
        breezeCount += 1;
      }

      const breezeLimit = parseInt(matrix.breeze, 10);

      if (breezeLimit > 0 && breezeCount > breezeLimit) {
        showSampleLimitModal();
        return false;
      }

      let limit = 0;

      if (regularCount > 0 && scarpaCount > 0) {
        limit = parseInt(matrix.mixed, 10);
      } else if (scarpaCount > 0) {
        limit = parseInt(matrix.scarpaOnly, 10);
      } else {
        limit = parseInt(matrix.regularOnly, 10);
      }

      if (!limit || Number.isNaN(limit)) return true;

      if (regularCount + scarpaCount > limit) {
        showSampleLimitModal();
        return false;
      }

      return true;
    } catch (_error) {
      return true;
    }
  }

  async function addVariantToCart(variantId, quantity, onSuccessDo, properties) {
    const sections = [];

    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections }
    }));

    const body = {
      id: variantId,
      quantity,
      properties: properties || {},
      sections: sections.join(','),
      sections_url: window.location.pathname + window.location.search
    };

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });

    const payload = await response.json();

    if (!response.ok) {
      throw new Error(payload.description || 'Unable to add item to cart.');
    }

    const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' })).json();
    cart.sections = payload.sections || {};

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        onSuccessDo,
        cart
      }
    }));
  }

  async function shouldBlockSampleCartQuantityChange(lineKey, targetQuantity) {
    const config = getSampleConfig();

    if (!config) return false;

    const matrix = config.isTrade ? config.tradeCustomer : config.regularCustomer;

    if (!matrix) return false;

    try {
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });

      if (!cartResponse.ok) return false;

      const cart = await cartResponse.json();
      const items = Array.isArray(cart.items) ? cart.items : [];
      const currentItem = items.find((item) => item.key === lineKey);

      if (!currentItem) return false;

      const currentHandle = String(currentItem.handle || '');
      const currentTitle = String(currentItem.title || currentItem.product_title || '').toLowerCase();
      const isCurrentSample = currentHandle.endsWith('-sample') || currentTitle.includes('sample');

      if (!isCurrentSample) return false;

      const sampleItems = items.filter((item) => {
        const handle = String(item.handle || '');
        const title = String(item.title || item.product_title || '').toLowerCase();

        return handle.endsWith('-sample') || title.includes('sample');
      }).map((item) => ({
        item,
        baseHandle: normalizeSampleBaseHandle(item.handle),
        quantity: item.key === lineKey ? targetQuantity : parseInt(item.quantity || 0, 10)
      }));

      const handles = [...new Set(sampleItems.map((entry) => entry.baseHandle).filter(Boolean))];
      const tagsByHandle = {};

      await Promise.all(handles.map(async (handle) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { cache: 'no-store' });

          if (!response.ok) return;

          const product = await response.json();
          const tags = Array.isArray(product.tags) ? product.tags.join(',') : String(product.tags || '');
          tagsByHandle[handle] = tags.toLowerCase();
        } catch (_error) {
        }
      }));

      let regularCount = 0;
      let scarpaCount = 0;
      let breezeCount = 0;

      sampleItems.forEach(({ baseHandle, quantity }) => {
        const qty = parseInt(quantity || 0, 10);

        if (!qty || qty <= 0) return;

        const tags = tagsByHandle[baseHandle] || '';
        const isScarpa = tags.includes('carlo_scarpa') || tags.includes('carlo-scarpa');
        const isBreeze = isBreezeTags(tags);

        if (isScarpa) {
          scarpaCount += qty;
        } else {
          regularCount += qty;
        }

        if (isBreeze) {
          breezeCount += qty;
        }
      });

      const breezeLimit = parseInt(matrix.breeze, 10);

      if (breezeLimit > 0 && breezeCount > breezeLimit) {
        showSampleLimitModal();
        return true;
      }

      let limit = 0;

      if (regularCount > 0 && scarpaCount > 0) {
        limit = parseInt(matrix.mixed, 10);
      } else if (scarpaCount > 0) {
        limit = parseInt(matrix.scarpaOnly, 10);
      } else if (regularCount > 0) {
        limit = parseInt(matrix.regularOnly, 10);
      }

      if (!limit || Number.isNaN(limit)) return false;

      if (regularCount + scarpaCount > limit) {
        showSampleLimitModal();
        return true;
      }

      return false;
    } catch (_error) {
      return false;
    }
  }

  window.__hcShouldBlockSampleCartQuantityChange = shouldBlockSampleCartQuantityChange;
  window.__hcEvaluateScarpaCheckoutGuard = evaluateScarpaCheckoutGuard;

  function getCalculatorPriceTarget(wrapper) {
    if (!wrapper) return null;

    const sectionRoot = wrapper.closest('.shopify-section');

    if (sectionRoot) {
      const scopedTarget = sectionRoot.querySelector('[data-hc-product-sale-price]');

      if (scopedTarget) return scopedTarget;
    }

    return document.querySelector('[data-hc-product-sale-price]');
  }

  function getActiveVariantMeta(scope) {
    if (!scope) return null;

    const formId = scope.dataset.productFormId;

    const inScopeActive = scope.querySelector('.hc-variant-meta[data-active="true"]');

    if (inScopeActive) return inScopeActive;

    const inScopeMeta = scope.querySelector('.hc-variant-meta');

    if (inScopeMeta) return inScopeMeta;

    if (!formId) return null;

    const linkedScopes = document.querySelectorAll(`[data-product-form-id="${formId}"]`);

    for (const linkedScope of linkedScopes) {
      const activeMeta = linkedScope.querySelector('.hc-variant-meta[data-active="true"]');

      if (activeMeta) return activeMeta;
    }

    for (const linkedScope of linkedScopes) {
      const meta = linkedScope.querySelector('.hc-variant-meta');

      if (meta) return meta;
    }

    return null;
  }

  function parseMaybeJson(value) {
    if (value == null) return null;
    if (typeof value === 'object') return value;
    const text = String(value || '').trim();
    if (!text) return null;

    try {
      const parsed = JSON.parse(text);
      if (typeof parsed === 'string') {
        try {
          return JSON.parse(parsed);
        } catch (_error) {
          return null;
        }
      }
      return parsed;
    } catch (_error) {
      return null;
    }
  }

  function normalizeDictionaryRows(dictionary, materialKey) {
    if (!dictionary) return [];
    if (Array.isArray(dictionary)) return dictionary;

    const direct = dictionary[materialKey];
    if (Array.isArray(direct)) return direct;

    const entries = Object.entries(dictionary);
    for (const [key, rows] of entries) {
      if (!Array.isArray(rows)) continue;
      const norm = String(key || '').toLowerCase().replace(/[+\-\s]/g, '_');
      if (materialKey === 'zellige' && norm.includes('zellige')) return rows;
      if (materialKey === 'cement_terrazzo' && (norm.includes('cement') || norm.includes('terrazzo'))) return rows;
      if (materialKey === 'breeze_block' && norm.includes('breeze')) return rows;
      if (materialKey === 'ceramic' && norm.includes('ceramic')) return rows;
      if (materialKey === 'finca' && norm.includes('finca')) return rows;
      if (materialKey === 'toba' && norm.includes('toba')) return rows;
      if (materialKey === 'tosca' && norm.includes('tosca')) return rows;
    }
    return [];
  }

  function getMaterialKeyFromTags(tagsCsv) {
    const tags = String(tagsCsv || '').toLowerCase();
    if (tags.includes('zellige')) return 'zellige';
    if (tags.includes('breeze')) return 'breeze_block';
    if (tags.includes('cement') || tags.includes('terrazzo')) return 'cement_terrazzo';
    if (tags.includes('ceramic') || tags.includes('custom_coll')) return 'ceramic';
    if (tags.includes('finca')) return 'finca';
    if (tags.includes('toba')) return 'toba';
    if (tags.includes('tosca')) return 'tosca';
    return '';
  }

  function getMappedDictionaryValues(wrapper) {
    if (!wrapper) return null;

    const tagsRaw = String(wrapper.dataset.productTags || '');
    const tags = tagsRaw.toLowerCase().split(',').map((t) => t.trim()).filter(Boolean);
    const tagSet = new Set(tags);
    const materialKey = getMaterialKeyFromTags(tagsRaw);

    if (!materialKey) return null;

    const dictionary = parseMaybeJson(wrapper.dataset.dictionaryRaw || '');
    const rows = normalizeDictionaryRows(dictionary, materialKey);
    if (!rows.length) return { materialKey, rowsCount: 0, category: '', item: '', pcsBox: 0, pcsSf: 0, sfBox: 0 };

    let category = '';
    for (const row of rows) {
      const c = String(row?.Category ?? row?.category ?? '').toLowerCase().trim();
      if (c && tagSet.has(c)) {
        category = c;
        break;
      }
    }

    let best = null;
    let bestScore = -1;
    if (category) {
      for (const row of rows) {
        const c = String(row?.Category ?? row?.category ?? '').toLowerCase().trim();
        if (c !== category) continue;
        const item = String(row?.Item ?? row?.item ?? '').toLowerCase().trim();
        const size = String(row?.Size ?? row?.size ?? '').toLowerCase().trim();
        const variation = String(row?.Variation ?? row?.variation ?? '').toLowerCase().trim();
        let score = 0;
        if (item && item !== '-' && tagSet.has(item)) score += 1;
        if (size && size !== '-' && tagSet.has(size)) score += 1;
        if (variation && variation !== '-' && tagSet.has(variation)) score += 1;
        if (score > bestScore) {
          bestScore = score;
          best = row;
        }
      }
    }

    let itemFallback = '';
    if (!best) {
      for (const row of rows) {
        const item = String(row?.Item ?? row?.item ?? '').toLowerCase().trim();
        if (item && item !== '-' && tagSet.has(item)) {
          best = row;
          itemFallback = item;
          break;
        }
      }
    }

    const pcsBox = parseFloat(best?.['PCS/Box'] ?? best?.pcs_box ?? 0) || 0;
    const pcsSf = parseFloat(best?.['PCS/SF'] ?? best?.pcs_sf ?? 0) || 0;
    const sfBox = parseFloat(best?.['SF/Box'] ?? best?.sf_box ?? 0) || 0;

    return { materialKey, rowsCount: rows.length, category, item: itemFallback, pcsBox, pcsSf, sfBox };
  }

  function syncCalculator(wrapper, options = {}) {
    if (!wrapper) return;
    const skipQuantityWrite = options.skipQuantityWrite === true;

    const input = wrapper.querySelector('.hc-ft-needed');
    const overage = wrapper.querySelector('.hc-overage');
    const totalFt = wrapper.querySelector('.hc-total-ft');
    const totalBoxes = wrapper.querySelector('.hc-total-boxes');
    const debugPcsBox = wrapper.querySelector('.hc-debug-pcs-box');
    const debugPcsSf = wrapper.querySelector('.hc-debug-pcs-sf');
    const debugSfBox = wrapper.querySelector('.hc-debug-sf-box');
    const priceSq = wrapper.querySelector('.hc-price-sq');
    const priceTile = wrapper.querySelector('.hc-price-tile');
    const formId = wrapper.dataset.productFormId;
    const priceTarget = getCalculatorPriceTarget(wrapper);
    const activeMeta = getActiveVariantMeta(wrapper);
    const quantityInput = formId ? document.querySelector(`input[name="quantity"][form="${formId}"]`) : null;

    if (!input || !activeMeta) return;

    const baseFtRaw = parseFloat(input.value || '0');
    const baseFt = baseFtRaw > 0 ? baseFtRaw : 1;
    const overagePct = parseInt(overage?.value || '0', 10) || 0;
    const price = parseInt(activeMeta.dataset.price || '0', 10) || 0;
    const pricePerTile = parseInt(activeMeta.dataset.priceTile || '0', 10) || 0;
    const mapped = getMappedDictionaryValues(wrapper);
    const sqfBoxMeta = parseFloat(activeMeta.dataset.sqfBox || '0') || 0;
    const pcsSqfMeta = parseFloat(activeMeta.dataset.pcsSqf || '0') || 0;
    const pcsBoxMeta = parseFloat(activeMeta.dataset.pcsBox || '0') || 0;
    const sqfBox = sqfBoxMeta > 0 ? sqfBoxMeta : (mapped?.sfBox || 0);
    const pcsSqf = pcsSqfMeta > 0 ? pcsSqfMeta : (mapped?.pcsSf || 0);
    const pcsBox = pcsBoxMeta > 0 ? pcsBoxMeta : (mapped?.pcsBox || 0);
    const calcType = wrapper.dataset.calculation || 'ft';
    const overFt = Math.ceil(baseFt + (baseFt * overagePct) / 100);
    const boxes = sqfBox > 0 ? Math.ceil(overFt / sqfBox) : 0;
    const quantity = calcType === 'box' ? boxes : overFt;
    const normalizedQuantity = quantity > 0 ? quantity : 1;

    if (baseFtRaw <= 0) {
      input.value = '1';
    }

    if (!skipQuantityWrite && quantityInput) {
      const nextQty = String(normalizedQuantity);
      if (quantityInput.value !== nextQty) {
        quantityInput.dataset.hcCalculatorUpdate = '1';
        quantityInput.value = nextQty;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(() => {
          delete quantityInput.dataset.hcCalculatorUpdate;
        }, 0);
      }
    }

    if (totalFt) totalFt.textContent = String(overFt || 0);
    if (totalBoxes) totalBoxes.textContent = String(boxes || 0);
    if (debugPcsBox) debugPcsBox.textContent = pcsBox > 0 ? String(pcsBox) : '-';
    if (debugPcsSf) debugPcsSf.textContent = pcsSqf > 0 ? String(pcsSqf) : '-';
    if (debugSfBox) debugSfBox.textContent = sqfBox > 0 ? String(sqfBox) : '-';
    const debugMaterial = wrapper.querySelector('.hc-debug-material');
    const debugRows = wrapper.querySelector('.hc-debug-material-rows');
    const debugCategory = wrapper.querySelector('.hc-debug-category');
    const debugItem = wrapper.querySelector('.hc-debug-item');
    if (debugMaterial && mapped?.materialKey) debugMaterial.textContent = mapped.materialKey;
    if (debugRows && mapped) debugRows.textContent = String(mapped.rowsCount || 0);
    if (debugCategory && mapped) debugCategory.textContent = mapped.category || '-';
    if (debugItem && mapped) debugItem.textContent = mapped.item || '-';
    if (priceSq) priceSq.textContent = formatMoney(price);
    if (priceTile) priceTile.textContent = formatMoney(pricePerTile);
    if (priceTarget) {
      const effectiveQuantity = normalizedQuantity;

      priceTarget.textContent = formatMoney(effectiveQuantity * price);
    }
  }

  function syncDisplayedProductPriceFromQuantity(wrapper) {
    if (!wrapper) return;

    const formId = wrapper.dataset.productFormId;
    const priceTarget = getCalculatorPriceTarget(wrapper);
    const activeMeta = getActiveVariantMeta(wrapper);
    const quantityInput = formId ? document.querySelector(`input[name="quantity"][form="${formId}"]`) : null;

    if (!priceTarget || !activeMeta || !quantityInput) return;

    const price = parseInt(activeMeta.dataset.price || '0', 10) || 0;
    const quantity = parseInt(quantityInput.value || '0', 10) || 0;
    const effectiveQuantity = quantity > 0 ? quantity : 1;

    if (quantity <= 0) {
      quantityInput.value = '1';
    }

    priceTarget.textContent = formatMoney(effectiveQuantity * price);
  }

  function syncCalculatorFromQuantity(wrapper) {
    if (!wrapper) return;

    const formId = wrapper.dataset.productFormId;
    const input = wrapper.querySelector('.hc-ft-needed');
    const overage = wrapper.querySelector('.hc-overage');
    const activeMeta = getActiveVariantMeta(wrapper);
    const quantityInput = formId ? document.querySelector(`input[name="quantity"][form="${formId}"]`) : null;

    if (!input || !activeMeta || !quantityInput) return;

    const mapped = getMappedDictionaryValues(wrapper);
    const sqfBoxMeta = parseFloat(activeMeta.dataset.sqfBox || '0') || 0;
    const sqfBox = sqfBoxMeta > 0 ? sqfBoxMeta : (mapped?.sfBox || 0);
    const overagePct = parseInt(overage?.value || '0', 10) || 0;
    const ratio = 1 + (overagePct / 100);
    const calcType = wrapper.dataset.calculation || 'ft';
    const quantity = parseInt(quantityInput.value || '0', 10) || 0;
    const effectiveQty = quantity > 0 ? quantity : 1;

    let overFt = effectiveQty;
    if (calcType === 'box') {
      overFt = sqfBox > 0 ? Math.ceil(effectiveQty * sqfBox) : effectiveQty;
    }

    const baseFt = Math.max(1, Math.ceil(overFt / ratio));
    input.value = String(baseFt);
    syncCalculator(wrapper, { skipQuantityWrite: true });
  }

  function activateVariantData(scope, variantId) {
    if (!scope || !variantId) return;

    scope.querySelectorAll('.hc-variant-meta').forEach((meta) => {
      meta.dataset.active = meta.dataset.id === String(variantId) ? 'true' : 'false';
    });

    const sampleMap = scope.querySelector(`.hc-sample-variant-map[data-main-variant="${variantId}"]`);

    scope.querySelectorAll('.hc-sample-button').forEach((button) => {
      if (sampleMap?.dataset.sampleVariant) {
        button.dataset.variant = sampleMap.dataset.sampleVariant;
      }

      if (sampleMap?.dataset.extraVariant) {
        button.dataset.extraVariant = sampleMap.dataset.extraVariant;
      } else {
        button.removeAttribute('data-extra-variant');
      }
    });
  }

  function createSectionRequestUrl(nextUrl, sectionId) {
    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return url;
  }

  function getControlSectionFromDocument(documentRoot, sectionId) {
    return documentRoot.querySelector(`[data-hc-load-more][data-section-id="${sectionId}"]`);
  }

  function getProductCardsFromDocument(documentRoot, productListId) {
    const nextProductList = documentRoot.getElementById(productListId);

    if (!nextProductList) return [];

    return Array.from(nextProductList.children).filter((child) => child.matches && child.matches('product-card'));
  }

  function getNextLoadMoreUrlFromDocument(documentRoot, sectionId) {
    const nextControl = getControlSectionFromDocument(documentRoot, sectionId);

    if (!nextControl) return '';

    return nextControl.dataset.nextUrl || '';
  }

  function prepareInjectedProductCard(card) {
    if (!card || !card.matches?.('product-card')) return;

    card.removeAttribute('reveal-on-scroll');
    card.style.opacity = '1';
    card.style.transform = 'none';

    card.querySelectorAll('[reveal-on-scroll]').forEach((element) => {
      element.removeAttribute('reveal-on-scroll');
    });

    card.querySelectorAll('.product-card__media, .product-card__image').forEach((element) => {
      element.style.opacity = '';
      element.style.visibility = '';
      element.style.transform = '';
    });
  }

  function isInfiniteLoadMode(controlRoot) {
    return controlRoot?.dataset.loadMode === 'infinite';
  }

  function normalizeTagFilterValue(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function normalizeTagFilterGroup(value) {
    const normalizedTokens = String(value || '')
      .split(/[|,]/)
      .map((token) => normalizeTagFilterValue(token))
      .filter(Boolean);

    const uniqueTokens = Array.from(new Set(normalizedTokens));

    if (uniqueTokens.length === 0) return 'all';
    if (uniqueTokens.length === 1 && uniqueTokens[0] === 'all') return 'all';

    return uniqueTokens.join('|');
  }

  function getTagFilterTokens(value) {
    const normalized = normalizeTagFilterGroup(value);

    if (normalized === 'all') return [];

    return normalized.split('|').filter(Boolean);
  }

  function getCollectionTagFilterRoot(productListId) {
    if (!productListId) return null;

    return document.querySelector(`[data-hc-tag-filter][data-product-list-id="${productListId}"]`);
  }

  function getActiveCollectionTagFilterValue(productListId) {
    const filterRoot = getCollectionTagFilterRoot(productListId);
    const currentValue = filterRoot?.dataset.activeFilter || filterRoot?.dataset.defaultFilter || 'all';

    return normalizeTagFilterGroup(currentValue || 'all');
  }

  function syncCollectionTagFilterUi(filterRoot, nextValue) {
    if (!filterRoot) return;

    filterRoot.querySelectorAll('[data-hc-tag-filter-option]').forEach((button) => {
      const optionValue = normalizeTagFilterGroup(button.dataset.tagFilterValue || 'all');
      const isActive = optionValue === nextValue;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const select = filterRoot.querySelector('[data-hc-tag-filter-select]');

    if (select && select.value !== nextValue) {
      select.value = nextValue;
    }
  }

  function applyCollectionTagFilter(productListId) {
    const productList = document.getElementById(productListId);

    if (!productList) return;

    const filterValue = getActiveCollectionTagFilterValue(productListId);
    const filterTokens = getTagFilterTokens(filterValue);
    const cards = Array.from(productList.querySelectorAll('product-card'));

    cards.forEach((card) => {
      if (filterTokens.length === 0) {
        card.hidden = false;
        return;
      }

      const rawIndex = String(card.dataset.hcTagIndex || '');
      const normalizedTags = rawIndex
        .split('|')
        .map((tag) => normalizeTagFilterValue(tag))
        .filter(Boolean);

      card.hidden = !filterTokens.some((token) => normalizedTags.includes(token));
    });
  }

  function hasVisibleFilteredCards(productListId) {
    const productList = document.getElementById(productListId);

    if (!productList) return false;

    return Array.from(productList.querySelectorAll('product-card')).some((card) => !card.hidden);
  }

  function setTagFilterBusy(filterRoot, isBusy) {
    if (!filterRoot) return;

    filterRoot.querySelectorAll('[data-hc-tag-filter-option]').forEach((button) => {
      button.disabled = isBusy;
      button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });

    const select = filterRoot.querySelector('[data-hc-tag-filter-select]');

    if (select) {
      select.disabled = isBusy;
    }
  }

  function getProductListItemCount(productListId) {
    const productList = document.getElementById(productListId);

    if (!productList) return 0;

    return productList.querySelectorAll('product-card').length;
  }

  function updateTagViewAllCta(filterRoot, nextValue) {
    const viewAllRoot = document.querySelector('[data-hc-tag-view-all]');
    const viewAllLink = viewAllRoot?.querySelector('[data-hc-tag-view-all-link]');

    if (!viewAllRoot || !viewAllLink || !filterRoot) return;

    if (nextValue === 'all') {
      viewAllRoot.hidden = true;
      viewAllLink.setAttribute('href', '#');
      return;
    }

    const productListId = filterRoot.dataset.productListId;
    const count = getProductListItemCount(productListId);
    const shouldShow = count > 50;

    if (!shouldShow) {
      viewAllRoot.hidden = true;
      viewAllLink.setAttribute('href', '#');
      return;
    }

    const tagUrl = buildTagPageUrl(filterRoot, nextValue);
    viewAllLink.setAttribute('href', tagUrl.toString());
    viewAllRoot.hidden = false;
  }

  function buildCollectionTagRequestUrl(filterRoot, nextValue) {
    const collectionUrl = String(filterRoot?.dataset?.collectionUrl || window.location.pathname).replace(/\/+$/, '');
    const requestPath = nextValue === 'all' ? collectionUrl : `${collectionUrl}/${nextValue}`;
    const requestUrl = new URL(requestPath, window.location.origin);
    const currentUrl = new URL(window.location.href);

    currentUrl.searchParams.forEach((value, key) => {
      if (key === 'page' || key === 'section_id') return;
      requestUrl.searchParams.set(key, value);
    });

    return requestUrl;
  }

  function getTagOptionUrl(filterRoot, nextValue) {
    if (!filterRoot) return '';

    const matchingOption = Array.from(filterRoot.querySelectorAll('[data-hc-tag-filter-option]')).find((option) => {
      const optionValue = normalizeTagFilterGroup(option.dataset.tagFilterValue || 'all');
      return optionValue === nextValue;
    });

    return matchingOption?.dataset?.tagFilterUrl || '';
  }

  function buildTagPageUrl(filterRoot, nextValue) {
    const explicitTagUrl = getTagOptionUrl(filterRoot, nextValue);
    const tagUrl = explicitTagUrl
      ? new URL(explicitTagUrl, window.location.origin)
      : buildCollectionTagRequestUrl(filterRoot, nextValue);
    const currentUrl = new URL(window.location.href);

    currentUrl.searchParams.forEach((value, key) => {
      if (key === 'page' || key === 'section_id') return;
      if (!tagUrl.searchParams.has(key)) {
        tagUrl.searchParams.set(key, value);
      }
    });

    tagUrl.searchParams.delete('page');
    tagUrl.searchParams.delete('section_id');

    return tagUrl;
  }

  function replaceCollectionProductsFromDocument(filterRoot, documentRoot) {
    if (!filterRoot || !documentRoot) return false;

    const productListId = filterRoot.dataset.productListId;
    const sectionId = filterRoot.dataset.sectionId;
    const currentProductList = document.getElementById(productListId);
    const nextProductList = documentRoot.getElementById(productListId);

    if (!productListId || !sectionId || !currentProductList || !nextProductList) return false;

    const nextChildren = Array.from(nextProductList.children).map((child) => child.cloneNode(true));

    nextChildren.forEach((child) => {
      prepareInjectedProductCard(child);
    });

    currentProductList.replaceChildren(...nextChildren);

    const currentControl = document.querySelector(`[data-hc-load-more][data-product-list-id="${productListId}"]`);
    const nextControl = getControlSectionFromDocument(documentRoot, sectionId);
    let activeControl = currentControl;

    if (nextControl) {
      const clonedNextControl = nextControl.cloneNode(true);

      if (currentControl) {
        currentControl.replaceWith(clonedNextControl);
      } else {
        currentProductList.insertAdjacentElement('afterend', clonedNextControl);
      }

      activeControl = clonedNextControl;
      setLoadMoreButtonVisibility(activeControl);
      refreshLoadMoreVisibility(activeControl);

      if (loadMoreObserver && isInfiniteLoadMode(activeControl)) {
        loadMoreObserver.observe(activeControl);
      }
    } else if (currentControl) {
      currentControl.remove();
      activeControl = null;
    }

    return Boolean(activeControl !== null || nextProductList);
  }

  async function applyCollectionTagFilterFromServer(filterRoot, nextValue) {
    if (!filterRoot) return false;

    const sectionId = filterRoot.dataset.sectionId;
    const productListId = filterRoot.dataset.productListId;

    if (!sectionId || !productListId) return false;

    const requestUrl = buildTagPageUrl(filterRoot, nextValue);
    const responseDocument = await fetchSectionDocument(requestUrl.toString(), sectionId);

    if (!responseDocument) return false;

    const replaced = replaceCollectionProductsFromDocument(filterRoot, responseDocument);

    if (!replaced) return false;

    filterRoot.dataset.activeFilter = nextValue;
    syncCollectionTagFilterUi(filterRoot, nextValue);
    applyCollectionTagFilter(productListId);
    window.history.replaceState({}, '', requestUrl.toString());

    return true;
  }

  async function loadCollectionTagUpToCount(filterRoot, minimumCount) {
    if (!filterRoot) return;

    const productListId = filterRoot.dataset.productListId;
    let guard = 0;

    while (getProductListItemCount(productListId) < minimumCount && guard < 20) {
      guard += 1;

      const controlRoot = document.querySelector(`[data-hc-load-more][data-product-list-id="${productListId}"]`);

      if (!controlRoot?.dataset?.nextUrl || controlRoot.dataset.loading === 'true') break;

      await loadMoreCollectionProducts(controlRoot);
    }
  }

  async function initCollectionTagFilterRoot(filterRoot) {
    if (!filterRoot || filterRoot.dataset.initialized === 'true') return;

    const productListId = filterRoot.dataset.productListId;

    if (!productListId) return;

    filterRoot.dataset.initialized = 'true';
    filterRoot.dataset.activeFilter = normalizeTagFilterGroup(filterRoot.dataset.defaultFilter || 'all');
    syncCollectionTagFilterUi(filterRoot, filterRoot.dataset.activeFilter);
    applyCollectionTagFilter(productListId);
    await loadCollectionTagUpToCount(filterRoot, 51);
  }

  function initCollectionTagFilters() {
    document.querySelectorAll('[data-hc-tag-filter]').forEach(initCollectionTagFilterRoot);
  }

  function setLoadMoreButtonVisibility(controlRoot) {
    const button = controlRoot?.querySelector('[data-hc-load-more-button]');

    if (!button) return;

    if (isInfiniteLoadMode(controlRoot)) {
      button.hidden = true;
    } else {
      button.hidden = false;
    }
  }

  async function fetchSectionDocument(url, sectionId) {
    const requestUrl = createSectionRequestUrl(url, sectionId);
    const response = await fetch(requestUrl.toString(), { cache: 'no-store' });

    if (!response.ok) return null;

    const html = await response.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  async function findNextVisibleLoadMoreState(initialUrl, sectionId, productListId) {
    let cursorUrl = initialUrl;
    let guard = 0;

    while (cursorUrl && guard < 20) {
      guard += 1;

      const tempContent = await fetchSectionDocument(cursorUrl, sectionId);

      if (!tempContent) return { cards: [], nextUrl: '', resolvedUrl: '', failed: true };

      const cards = getProductCardsFromDocument(tempContent, productListId);
      const nextUrl = getNextLoadMoreUrlFromDocument(tempContent, sectionId);

      if (cards.length > 0 || !nextUrl) {
        return { cards, nextUrl, resolvedUrl: cursorUrl, failed: false };
      }

      cursorUrl = nextUrl;
    }

    return { cards: [], nextUrl: '', resolvedUrl: '', failed: false };
  }

  async function refreshLoadMoreVisibility(controlRoot) {
    if (!controlRoot || controlRoot.dataset.loading === 'true' || controlRoot.dataset.resolving === 'true') return;

    const nextUrl = controlRoot.dataset.nextUrl;
    const sectionId = controlRoot.dataset.sectionId;
    const productListId = controlRoot.dataset.productListId;
    const button = controlRoot.querySelector('[data-hc-load-more-button]');

    if (!nextUrl || !sectionId || !productListId || !button) return;

    controlRoot.dataset.resolving = 'true';
    button.disabled = true;

    try {
      const state = await findNextVisibleLoadMoreState(nextUrl, sectionId, productListId);

      if (state.failed) {
        button.disabled = false;
        return;
      }

      if (state.cards.length === 0) {
        controlRoot.remove();
        return;
      }

      controlRoot.dataset.nextUrl = state.resolvedUrl || nextUrl;
      button.disabled = false;
    } catch (_error) {
      button.disabled = false;
    } finally {
      if (document.body.contains(controlRoot)) {
        controlRoot.dataset.resolving = 'false';
      }
    }
  }

  async function loadMoreCollectionProducts(controlRoot) {
    if (!controlRoot || controlRoot.dataset.loading === 'true') return;

    const nextUrl = controlRoot.dataset.nextUrl;
    const sectionId = controlRoot.dataset.sectionId;
    const productListId = controlRoot.dataset.productListId;
    const button = controlRoot.querySelector('[data-hc-load-more-button]');

    if (!nextUrl || !sectionId || !productListId || !button) return;

    const currentProductList = document.getElementById(productListId);

    if (!currentProductList) return;

    controlRoot.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const state = await findNextVisibleLoadMoreState(nextUrl, sectionId, productListId);

      if (state.failed) {
        window.location.href = nextUrl;
        return;
      }

      if (state.cards.length === 0) {
        controlRoot.remove();
        return;
      }

      const fragment = document.createDocumentFragment();
      state.cards.forEach((card) => {
        const clonedCard = card.cloneNode(true);
        prepareInjectedProductCard(clonedCard);
        fragment.appendChild(clonedCard);
      });
      currentProductList.appendChild(fragment);
      applyCollectionTagFilter(productListId);
      const activeFilterValue = getActiveCollectionTagFilterValue(productListId);

      if (state.nextUrl) {
        controlRoot.dataset.nextUrl = state.nextUrl;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        setLoadMoreButtonVisibility(controlRoot);

        if (activeFilterValue !== 'all' && !hasVisibleFilteredCards(productListId)) {
          await loadMoreCollectionProducts(controlRoot);
        }
      } else {
        controlRoot.remove();
      }
    } catch (_error) {
      window.location.href = nextUrl;
    } finally {
      if (document.body.contains(controlRoot)) {
        controlRoot.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }
    }
  }

  document.addEventListener('click', async (event) => {
    const sampleButton = event.target.closest('.hc-sample-button');
    const closeButton = event.target.closest('[data-hc-close]');
    const overlay = event.target.closest('[data-hc-modal-overlay]');

    if (closeButton) {
      closeSampleLimitModal();
      return;
    }

    if (overlay && event.target === overlay) {
      closeSampleLimitModal();
      return;
    }

    if (!sampleButton) return;

    event.preventDefault();

    const variantId = parseInt(sampleButton.dataset.variant || '0', 10);

    if (!variantId) return;

    const allowed = await canAddSample(sampleButton.dataset.sampleType || 'regular', sampleButton.dataset.baseHandle || '');

    if (!allowed) return;

    sampleButton.setAttribute('aria-busy', 'true');

    try {
      const properties = {};

      if (sampleButton.dataset.extraVariant) {
        properties._sev = sampleButton.dataset.extraVariant;
      }

      await addVariantToCart(variantId, 1, 'force_open_drawer', properties);
    } catch (error) {
      alert(error.message);
    } finally {
      sampleButton.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSampleLimitModal();
    }
  });

  document.addEventListener('click', async (event) => {
    const filterButton = event.target.closest('[data-hc-tag-filter-option]');

    if (filterButton) {
      const filterRoot = filterButton.closest('[data-hc-tag-filter]');
      const productListId = filterRoot?.dataset.productListId;

      if (!filterRoot || !productListId) return;

      event.preventDefault();

      const nextValue = normalizeTagFilterGroup(filterButton.dataset.tagFilterValue || 'all');
      filterRoot.dataset.activeFilter = nextValue;
      syncCollectionTagFilterUi(filterRoot, nextValue);
      applyCollectionTagFilter(productListId);
      setTagFilterBusy(filterRoot, true);

      try {
        const loaded = await applyCollectionTagFilterFromServer(filterRoot, nextValue);

        if (!loaded) {
          applyCollectionTagFilter(productListId);
        }

        await loadCollectionTagUpToCount(filterRoot, 51);

        updateTagViewAllCta(filterRoot, nextValue);
      } finally {
        setTagFilterBusy(filterRoot, false);
      }

      return;
    }

    const loadMoreButton = event.target.closest('[data-hc-load-more-button]');

    if (!loadMoreButton) return;

    const controlRoot = loadMoreButton.closest('[data-hc-load-more]');

    if (!controlRoot) return;

    event.preventDefault();
    loadMoreCollectionProducts(controlRoot);
  });

  document.addEventListener('change', async (event) => {
    const select = event.target.closest('[data-hc-tag-filter-select]');

    if (!select) return;

    const filterRoot = select.closest('[data-hc-tag-filter]');
    const productListId = filterRoot?.dataset.productListId;

    if (!filterRoot || !productListId) return;

    const nextValue = normalizeTagFilterGroup(select.value || 'all');
    filterRoot.dataset.activeFilter = nextValue;
    syncCollectionTagFilterUi(filterRoot, nextValue);
    applyCollectionTagFilter(productListId);
    setTagFilterBusy(filterRoot, true);

    try {
      const loaded = await applyCollectionTagFilterFromServer(filterRoot, nextValue);

      if (!loaded) {
        applyCollectionTagFilter(productListId);
      }

      await loadCollectionTagUpToCount(filterRoot, 51);

      updateTagViewAllCta(filterRoot, nextValue);
    } finally {
      setTagFilterBusy(filterRoot, false);
    }
  });

  let loadMoreObserver = null;

  function initInfiniteLoadMore() {
    if (loadMoreObserver) {
      loadMoreObserver.disconnect();
    }

    if (!('IntersectionObserver' in window)) return;

    loadMoreObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const controlRoot = entry.target;

        if (!controlRoot?.dataset?.nextUrl || controlRoot.dataset.loading === 'true' || controlRoot.dataset.resolving === 'true') {
          return;
        }

        loadMoreCollectionProducts(controlRoot);
      });
    }, { rootMargin: '300px 0px' });

    document.querySelectorAll('[data-hc-load-more]').forEach((controlRoot) => {
      setLoadMoreButtonVisibility(controlRoot);

      if (!isInfiniteLoadMode(controlRoot)) return;

      loadMoreObserver.observe(controlRoot);
    });
  }

  document.addEventListener('click', (event) => {
    const checkoutTarget = event.target.closest('button[name="checkout"], .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    const guardState = window.__hcScarpaGuardState;

    if (!checkoutTarget || !guardState?.blocked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showSampleLimitModal(guardState.message);
  }, true);

  document.addEventListener('submit', (event) => {
    const target = event.target;
    const isCartForm = target?.matches?.('form.cart-page, form.cart-drawer__footer');
    const guardState = window.__hcScarpaGuardState;

    if (!isCartForm || !guardState?.blocked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showSampleLimitModal(guardState.message);
  }, true);

  document.addEventListener('input', (event) => {
    const wrapper = event.target.closest('.hc-ft-calculator');

    if (wrapper && event.target.matches('.hc-ft-needed')) {
      syncCalculator(wrapper);
      return;
    }

    if (wrapper && event.target.matches('.hc-overage')) {
      syncCalculator(wrapper);
      return;
    }

    if (event.target.matches('input[name="quantity"][form]')) {
      if (event.target.dataset.hcCalculatorUpdate === '1') return;
      const formId = event.target.getAttribute('form');

      if (!formId) return;

      document.querySelectorAll(`.hc-ft-calculator[data-product-form-id="${formId}"]`).forEach(syncCalculatorFromQuantity);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.hc-overage')) {
      syncCalculator(event.target.closest('.hc-ft-calculator'));
      return;
    }

    if (event.target.matches('input[name="quantity"][form]')) {
      if (event.target.dataset.hcCalculatorUpdate === '1') return;
      const formId = event.target.getAttribute('form');

      if (!formId) return;

      document.querySelectorAll(`.hc-ft-calculator[data-product-form-id="${formId}"]`).forEach(syncCalculatorFromQuantity);
      return;
    }

    const form = event.target.form;

    if (!form || event.target.name !== 'id') return;

    document.querySelectorAll(`[data-product-form-id="${form.id}"]`).forEach((scope) => {
      activateVariantData(scope, event.target.value);

      const calculator = scope.matches('.hc-ft-calculator') ? scope : scope.querySelector('.hc-ft-calculator');

      if (calculator) {
        syncCalculator(calculator);
      }
    });
  });

  function initScope(scope) {
    const formId = scope.dataset.productFormId;

    if (!formId) return;

    const form = document.getElementById(formId);
    const variantId = form?.querySelector('[name="id"]')?.value;

    activateVariantData(scope, variantId);

    const calculator = scope.matches('.hc-ft-calculator') ? scope : scope.querySelector('.hc-ft-calculator');

    if (calculator) {
      syncCalculator(calculator);
    }
  }

  function initMegaMenuHoverSwap() {
    if (window.__hcMegaMenuHoverSwapInit) return;
    window.__hcMegaMenuHoverSwapInit = true;

    const imageCache = new Map();
    const activeLinkByMenu = new WeakMap();
    const requestTokenByMenu = new WeakMap();

    const canLoad = (url) => new Promise((resolve) => {
      if (!url) {
        resolve(false);
        return;
      }

      if (imageCache.has(url)) {
        resolve(imageCache.get(url));
        return;
      }

      const probe = new Image();
      probe.onload = () => {
        imageCache.set(url, true);
        resolve(true);
      };
      probe.onerror = () => {
        imageCache.set(url, false);
        resolve(false);
      };
      probe.src = url;
    });

    const getPromoImage = (menu) => {
      return menu?.querySelector('.mega-menu__promo .zoom-image, .mega-menu__promo img');
    };

    const getDefaultPromoImage = (imageEl) => {
      if (!imageEl.dataset.defaultPromoImage) {
        imageEl.dataset.defaultPromoImage = imageEl.currentSrc || imageEl.src || '';
      }

      if (!imageEl.dataset.defaultPromoImageSrcset) {
        imageEl.dataset.defaultPromoImageSrcset = imageEl.getAttribute('srcset') || '';
      }

      return imageEl.dataset.defaultPromoImage;
    };

    const applyImage = (imageEl, url) => {
      if (!imageEl || !url) return;
      imageEl.src = url;
      imageEl.setAttribute('src', url);
      imageEl.removeAttribute('srcset');
    };

    const setPromoImage = async (linkEl) => {
      const menu = linkEl.closest('.mega-menu');
      const imageEl = getPromoImage(menu);

      if (!imageEl) return;
      activeLinkByMenu.set(menu, linkEl);
      const nextToken = (requestTokenByMenu.get(menu) || 0) + 1;
      requestTokenByMenu.set(menu, nextToken);

      const defaultImage = getDefaultPromoImage(imageEl);
      const fileImageCandidates = linkEl.dataset.hoverFileImages || linkEl.dataset.hoverFileImage || '';
      const fileImages = fileImageCandidates.split('|').filter(Boolean);
      const collectionImage = linkEl.dataset.hoverCollectionImage || '';

      let nextImage = defaultImage;

      if (collectionImage) {
        nextImage = collectionImage;
      }

      applyImage(imageEl, nextImage);

      for (const fileImage of fileImages) {
        if (await canLoad(fileImage)) {
          if (requestTokenByMenu.get(menu) !== nextToken) return;
          const activeElement = document.activeElement;
          if (activeLinkByMenu.get(menu) === linkEl || linkEl === activeElement) {
            applyImage(imageEl, fileImage);
          }
          break;
        }
      }
    };

    const resetPromoImage = (linkEl) => {
      const menu = linkEl.closest('.mega-menu');
      const imageEl = getPromoImage(menu);

      if (!imageEl) return;
      if (activeLinkByMenu.get(menu) !== linkEl) return;
      activeLinkByMenu.delete(menu);
      requestTokenByMenu.set(menu, (requestTokenByMenu.get(menu) || 0) + 1);

      const defaultImage = getDefaultPromoImage(imageEl);
      const defaultSrcset = imageEl.dataset.defaultPromoImageSrcset || '';

      if (defaultImage) {
        imageEl.src = defaultImage;
        imageEl.setAttribute('src', defaultImage);
      }

      if (defaultSrcset) {
        imageEl.setAttribute('srcset', defaultSrcset);
      } else {
        imageEl.removeAttribute('srcset');
      }
    };

    document.addEventListener('mouseover', (event) => {
      const linkEl = event.target.closest('.mega-menu__third-link');
      if (!linkEl) return;
      if (event.relatedTarget && linkEl.contains(event.relatedTarget)) return;
      if (activeLinkByMenu.get(linkEl.closest('.mega-menu')) === linkEl) return;
      setPromoImage(linkEl);
    });

    document.addEventListener('focusin', (event) => {
      const linkEl = event.target.closest('.mega-menu__third-link');
      if (!linkEl) return;
      setPromoImage(linkEl);
    });

    document.addEventListener('mouseout', (event) => {
      const linkEl = event.target.closest('.mega-menu__third-link');
      if (!linkEl) return;
      if (event.relatedTarget && linkEl.contains(event.relatedTarget)) return;
      const nextLink = event.relatedTarget?.closest?.('.mega-menu__third-link');
      if (nextLink) return;
      resetPromoImage(linkEl);
    });

    document.addEventListener('focusout', (event) => {
      const linkEl = event.target.closest('.mega-menu__third-link');
      if (!linkEl) return;
      resetPromoImage(linkEl);
    });
  }

  function initVariantOptionViewAll() {
    window.__HC_VARIANT_VIEW_ALL_STATE__ = window.__HC_VARIANT_VIEW_ALL_STATE__ || {};
    const expandedState = window.__HC_VARIANT_VIEW_ALL_STATE__;
    const wrappers = document.querySelectorAll('.variant-picker__option');

    wrappers.forEach((wrapper) => {
      const values = wrapper.querySelector('[data-hc-variant-values]');
      const toggle = wrapper.querySelector('[data-hc-variant-toggle]');

      if (!values || !toggle) return;
      const stateKey = [
        wrapper.closest('variant-picker')?.getAttribute('form') || '',
        wrapper.querySelector('.variant-picker__option-info label')?.textContent?.trim() || '',
        values.dataset.hcCollapsedLimit || '6'
      ].join('::');
      const wasExpanded = expandedState[stateKey] === true || values.classList.contains('is-expanded') || toggle.getAttribute('aria-expanded') === 'true';

      const controls = Array.from(values.querySelectorAll('.hc-variant-option-item'));
      const limit = parseInt(values.dataset.hcCollapsedLimit || '6', 10) || 6;

      controls.forEach((control, index) => {
        control.classList.toggle('hc-variant-option-hidden', index >= limit);
      });

      const hasHidden = controls.length > limit;
      const shouldExpand = hasHidden && wasExpanded;
      values.classList.toggle('is-expanded', shouldExpand);
      toggle.classList.toggle('is-expanded', shouldExpand);
      toggle.hidden = !hasHidden;
      toggle.textContent = shouldExpand ? 'View Less' : 'View All';
      toggle.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
      expandedState[stateKey] = shouldExpand;

      if (!hasHidden) return;
      if (toggle.dataset.hcBound === 'true') return;

      toggle.dataset.hcBound = 'true';
      toggle.addEventListener('click', () => {
        const expanded = values.classList.toggle('is-expanded');
        toggle.textContent = expanded ? 'View Less' : 'View All';
        toggle.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        expandedState[stateKey] = expanded;
      });
    });
  }

  function initAllScopes() {
    initCollectionTagFilters();
    initMegaMenuHoverSwap();
    initVariantOptionViewAll();
    document.querySelectorAll('[data-product-form-id]').forEach(initScope);
    document.querySelectorAll('[data-hc-load-more]').forEach((controlRoot) => {
      setLoadMoreButtonVisibility(controlRoot);
      refreshLoadMoreVisibility(controlRoot);
    });
    initInfiniteLoadMore();
    scheduleScarpaGuardEvaluation(undefined, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllScopes, { once: true });
  } else {
    initAllScopes();
  }

  document.addEventListener('shopify:section:load', initAllScopes);
  document.addEventListener('variant:change', () => {
    initVariantOptionViewAll();
  });
  document.addEventListener('product:rerender', () => {
    initVariantOptionViewAll();
  });
  document.addEventListener('cart-drawer:refreshed', () => {
    initAllScopes();
    scheduleScarpaGuardEvaluation(undefined, 0);
  });
  document.addEventListener('line-item:change', () => {
    scheduleScarpaGuardEvaluation(undefined, 120, true);
  });
  document.addEventListener('cart:change', (event) => {
    scheduleScarpaGuardEvaluation(event.detail?.cart, 0, true);
  });
})();
